import { DashboardState, LeftPanelType } from "@kuika/kuika-cl-model";
import type { IScreenDesignContextState } from "../../../../contexts/screen-design-context/screen-design-context";
import { requestProcessEditorTab } from "./process-editor-tab-bus";
import { PROCESS_TAB_FORMS } from "./process-editor-tabs";

/**
 * Navigate to the Process Automation tool and open the process editor's **Forms** tab — the
 * replacement for the retired step-screen wizard shortcuts on the screen lists (the wizard modal is
 * superseded by the Forms tab for step-screen setup). Mirrors the Issues panel's redirect
 * (`handleRedirectToProcessAutomationAndFocusItem`): save the open screen before leaving the design
 * tool, switch the dashboard, then select the process when one is given — otherwise the flows tool
 * restores the last open process itself. The tab request is retained by the bus until the process
 * editor mounts.
 */
export const redirectToProcessForms = async (sd: IScreenDesignContextState, processId?: string): Promise<void> => {
  if (sd.dashboardState !== DashboardState.workFlow) {
    await sd.saveScreen(true);
    sd.setDashboardState(DashboardState.workFlow);
    sd.setActiveLeftPanelByClick(LeftPanelType.WorkFlowList);
  }
  if (processId) await sd.setSelectedWf(processId);
  requestProcessEditorTab(PROCESS_TAB_FORMS);
};
